// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "海上风力发电技术",
      "tec": "于子淞张雪岩",
      "week": "1-12周",
      "add": "教学楼B座325能动"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "风电机组检测与故障诊断",
      "tec": "殷孝雎",
      "week": "1-12周",
      "add": "教学楼D座215经管"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "新能源政策与法律法规（讲座）",
      "tec": "陈琳",
      "week": "5-8周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "可再生能源经济技术评估",
      "tec": "杜远卓",
      "week": "1-12周",
      "add": "教学楼C座112教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "光伏电站运行与故障检修",
      "tec": "杜远卓",
      "week": "1-12周",
      "add": "教学楼D座215经管"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "工程项目可研报告撰写（讲座）",
      "tec": "刘姝",
      "week": "1-4周",
      "add": "教学楼C座112教务"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
